module.exports = lincd;